<template>
  <div class="column content-box">
    <woot-modal-header
      :header-title="$t('INTEGRATION_SETTINGS.ASSISTENT.EDIT.TITLE')"
    />
    <assistent-form
        :value="value"
        :is-submitting="uiFlags.creatingItem"
        @submit="onSubmit"
        @cancel="onClose"
      />
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import AssistentForm from './AssistentForm';

export default {
  components: {
    AssistentForm,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({ uiFlags: 'assistent/getUIFlags' }),
  },
  methods: {
    async onSubmit(assistent) {
      try {
        await this.$store.dispatch('assistent/update', {
          assistent,
          id: this.id,
        });
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.ASSISTENT.EDIT.API.SUCCESS_MESSAGE')
        );
        this.onClose();
      } catch (error) {
        const alertMessage =
          error.response.data.message ||
          this.$t('INTEGRATION_SETTINGS.ASSISTENT.EDIT.API.ERROR_MESSAGE');
        this.showAlert(alertMessage);
      }
    },
  },
};
</script>
